<template>
  <v-container v-if="busy === false"
               fluid>
    <PageTitle>
      Text Message Configurations
      <template v-slot:buttons>
        <v-btn color="primary">
          New Configuration
        </v-btn>
      </template>
    </PageTitle>
    <v-card class="mb-4">
      <v-simple-table>
        <thead>
        <tr>
          <th>
            Code
          </th>
          <th>
            Registration URL
          </th>
          <th>
            Phone Number
          </th>
          <th>
            Message Prefix
          </th>
          <th>
            Privacy Policy URL
          </th>
          <th>
            Terms of Service URL
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="configuration in configurations"
            :key="configuration.id">
          <td>
            <router-link :to="{name: 'admin.sinch_configuration.edit', params: {configurationID: configuration.id}}">
              {{ configuration.code }}
            </router-link>
          </td>
          <td>
            <a :href="configuration.registration_url"
               target="_blank">
              Registration
            </a>
          </td>
          <td>
            {{ configuration.source_number }}
          </td>
          <td>
            {{ configuration.message_prefix }}
          </td>
          <td>
            {{ configuration.privacy_policy_url }}
          </td>
          <td>
            {{ configuration.terms_url }}
          </td>
        </tr>
        </tbody>
      </v-simple-table>

    </v-card>
  </v-container>
</template>
<script>
import PageTitle from '../../components/PageTitle.vue';
import {mapGetters} from 'vuex';

export default {
  components: {PageTitle},
  data() {
    return {
      busy: false,
    }
  },
  computed: {
    ...mapGetters('sinch', [
      'configurations',
    ]),
  },
  async created() {
    this.busy = true;
    await this.fetchData();
    this.busy = false;
  },
  methods: {
    async fetchData() {
      await this.$store.dispatch('sinch/fetchConfigurations')
      if (this.configurations.length === 1) {
        await this.$router.replace({name: 'admin.sinch_configuration.edit', params: {configurationID: this.configurations[0].id}})
      }
    }
  }
}
</script>
